import Image from "next/image";
import SvgComparison from "../svg/SvgComparison";
import {ImgComparisonSlider} from "@img-comparison-slider/react";
import {useEffect, useRef, useState} from "react";
import {mapNumber} from "../helpers/numbers";

export default function ImageComparison({before, after, value = 0}) {

    const refContainer = useRef();
    const [imgValue, setImgValue] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            if (refContainer.current) {
                const winHeight = window.innerHeight;
                const nowScroll = refContainer.current.getBoundingClientRect().y;

                if (nowScroll > winHeight / -2) {
                    const val = mapNumber(nowScroll, winHeight / 2, 0, 0, 100, true).toFixed(1);
                    setImgValue(val);
                }
            }
        }

        window?.addEventListener('scroll', handleScroll);
        handleScroll();

        return () => window?.removeEventListener('scroll', handleScroll)
    }, []);

    return (
        <div ref={refContainer}>
            <ImgComparisonSlider className="comparison cursor-pointer" value={imgValue}>
                <div slot="first">
                    <Image src={before}
                           priority
                           alt=""
                    />
                </div>
                <div slot="second">
                    <Image src={after}
                           priority
                           alt=""
                    />
                </div>
                <div slot="handle"
                     className="w-12 h-12 bg-white rounded-full inline-flex cursor-pointer comparison-handle">
                    <SvgComparison width={30} className="m-auto"/>
                </div>
            </ImgComparisonSlider>
        </div>
    )
}
